import React from 'react';
import { Navigate } from 'react-router-dom';
import { useGodModeAuth } from '../contexts/GodModeAuthContext';
import { Loader2 } from 'lucide-react';

interface GodModeProtectedRouteProps {
  children: React.ReactNode;
}

export const GodModeProtectedRoute: React.FC<GodModeProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, loading } = useGodModeAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-slate-950">
        <Loader2 className="w-8 h-8 animate-spin text-cyan-500" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/godmode/auth" replace />;
  }

  return <>{children}</>;
};
